import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import { useDebounce } from 'use-lodash-debounce'
import Map from "./Map";
import { Layers, TileLayer, VectorLayer } from "./Layers";
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { osm, vector } from "./Source";
import { fromLonLat, toLonLat, get, transform } from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import { Controls, FullScreenControl } from "./Controls";
import Interaction from './Interaction'
import DotLoader from "../Common/Loaders/DotLoader";

let styles = {
	'Point': new Style({
		image: new CircleStyle({
			radius: 10,
			fill: null,
			stroke: new Stroke({
				color: 'magenta',
			}),
		}),
	}),
	'Polygon': new Style({
		stroke: new Stroke({
			color: 'purple',
			lineDash: [4],
			width: 3,
		}),
		fill: new Fill({
			color: 'rgba(231, 111, 252, 0.1)',
		}),
	}),
	'MultiPolygon': new Style({
		stroke: new Stroke({
			color: 'purple',
			width: 1,
		}),
		fill: new Fill({
			color: 'rgba(231, 111, 252, 0.1)',
		}),
	}),
};

const geojsonObject = {
	"type": "FeatureCollection",
	"features": [
		{
			"type": "Feature",
			"properties": {
				"kind": "county",
				"name": "Ystad",
				"state": "ystad"
			},
			// "geometry": {
			// 	"type": "MultiPolygon",
			// 	"coordinates": [
			// 		[
			// 			[
			// 				[
			// 					-94.5998,
			// 					39.1582
			// 				],
			// 				[
			// 					-94.7422,
			// 					39.1691
			// 				],
			// 				[
			// 					-94.7751,
			// 					39.202
			// 				],
			// 				[
			// 					-94.8627,
			// 					39.202
			// 				]
			// 			]
			// 		]
			// 	]
			// }
		}
	]
};
const geojsonObject2 = {
	"type": "FeatureCollection",
	"features": [
		{
			"type": "Feature",
			"properties": {
				"kind": "county",
				"name": "Malmö",
				"state": "malmo"
			},
			// "geometry": {
			// 	"type": "MultiPolygon",
			// 	"coordinates": [
			// 		[
			// 			[
			// 				[
			// 					13.00073,
			// 					55.60587 
			// 				],
			// 				[
			// 					13.00080,
			// 					55.60567 
			// 				],
			// 				[
			// 					13.00093,
			// 					55.60557 
			// 				],
			// 				[
			// 					13.00100,
			// 					55.60597 
			// 				],
			// 			]
			// 		]
			// 	]
			// }
		}
	]
};

const createFeatures = features => features ? new GeoJSON().readFeatures(features) : null

function getUserCoords() {
	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(resolve, reject)
	})
}

const OpenLayersMAP = props => {
	const { save,id, value = {}, extra={}, disabled, builder = false } = props
	
	const { features = null } = value
	const { defaultMap={} } = extra

	const [userCoords, setUserCoords] = useState(null)

	useEffect(() => {
		async function getC() {
			try {
				const userCoords = await getUserCoords()
				const newCoords = [userCoords.coords.longitude, userCoords.coords.latitude]

				setCenter(newCoords)
				setUserCoords(newCoords)
			} catch(err) {
				console.error("OLMap, could not get user coordinates - ", err)
				setCenter([13.8200,55.4295])
				setUserCoords([13.8200,55.4295])
			}
		}
		
		if(builder) getC()
	}, [])

	// const [center, setCenter] = useState(value.center ? value.center : [13.8200,55.4295 ]);
	const [center, setCenter] = useState(() => value.center || defaultMap.center || [13.8200,55.4295 ]);
	const [zoom, setZoom] = useState(() => value.zoom || defaultMap.zoom || 13);
	const [drawLayer, setDrawLater] = useState(() => vector({ 
		features: createFeatures(features || defaultMap.features)
	}))
	const [showLayer2, setShowLayer2] = useState(false);


	const _save = ( (map={ getView: () => ({ getZoom() {}, getCenter() {} })}) => {
		const features = drawLayer.getFeatures();
        let GEOJSON_PARSER = new GeoJSON();
        let featuresJSON = GEOJSON_PARSER.writeFeaturesObject(features);

		const zoom = map.getView().getZoom();
		const center = map.getView().getCenter();


		const data = { 
			value : {
				features: featuresJSON,
				zoom,
				center: toLonLat(center)
			} 
		}

		if(props.builder) {
			const dataFormBuilder = Object.assign(data, { key: "defaultMap", _id: id })
			save(dataFormBuilder)
		} else {
			const dataPortal = Object.assign(data, { key: id })
			save(dataPortal)
		}

	}) //, [id,drawLayer])

	if(!userCoords && builder) {
		return (
			<div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
				<h3>Försöker hämta din position</h3>
				<DotLoader />
			</div>
		)
	}


	return (
		<div onClick={e => console.log(e)}>
			<Map center={fromLonLat(center)} zoom={zoom} disabled={disabled} setCenter={setCenter}>
				{
					! disabled && <Interaction source={drawLayer} save={_save}/>
				}
				<Layers>
					<TileLayer
						source={osm()}
						zIndex={0}
					/>
					{drawLayer && (
						<VectorLayer
							source={drawLayer}
							//style={styles.Point}
						/>
					)}
					{showLayer2 && (
						<VectorLayer
							source={vector({ features: new GeoJSON().readFeatures(geojsonObject2, { featureProjection: get('EPSG:3857') }) })}
							style={styles.MultiPolygon}
						/>
					)}
				</Layers>
				<Controls>
					<FullScreenControl />
				</Controls>
			</Map>
			{/* <div>
				<input
					type="checkbox"
					checked={showLayer1}
					onChange={event => setShowLayer1(event.target.checked)}
				/> Malmö stad
			</div> */}
			{/* <div>
				<input
					type="checkbox"
					checked={showLayer2}
					onChange={event => setShowLayer2(event.target.checked)}
				/> Ystad</div> */}
		</div>
	);
}

export default OpenLayersMAP
